export default __webpack_public_path__ + "static/media/identify.d87fe1af.png";